import type { SmartDrawerProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { Drawer } from './Dialog';
import './index.less';

function SmartDrawer(props: SmartDrawerProps, ref: React.Ref<HTMLDivElement>) {
  const { children, maskClick, id, priority, fullScreen = false, className, ...rest } = props;

  return (
    <Drawer.Root {...rest}>
      <Drawer.Portal>
        <Drawer.Overlay
          className="wg-smart-drawer__overlay"
          onClick={maskClick}
        />
        <Drawer.Content
          ref={ref}
          id={id}
          className={cn(
            'wg-smart-drawer__content',
            {
              'wg-smart-drawer__content--high': priority === 'high',
              'wg-smart-drawer__content--low': priority === 'low',
              'wg-smart-drawer__content--fullscreen': fullScreen,
            },
            className,
          )}
        >
          <div className="wg-smart-drawer__content-area">
            <div className="wg-smart-drawer__centered-content">{children}</div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

const SmartDrawerComponent = forwardRef<HTMLDivElement, SmartDrawerProps>(SmartDrawer);

SmartDrawerComponent.displayName = 'SmartDrawer';

export default SmartDrawerComponent;

export type { SmartDrawerPriority, SmartDrawerProps } from './const';
